var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-back",on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"name":"arrow-left","color":"black"}}),_vm._v(" Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }